import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetFixedAssetsResponse } from '@/api/handlers/resources/fixedAssets/responses';
import type { FixedAssetListQuery } from '@/api/handlers/resources/fixedAssets/requests';
import type { ApiResponse } from '@/api/handlers/responses';
import { FixedAssetQueryKeys } from './fixedAssetQueryKeys';

const STALE_TIME_MS = 60_000;

/**
 * The asset register for a status filter + name search. `keepPreviousData` keeps
 * the current rows on screen while a filter change loads, so the summary cards
 * and the tie-out don't blink between two valid states.
 */
export const useFixedAssetsQuery = (query: FixedAssetListQuery) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetFixedAssetsResponse>>({
        queryKey: FixedAssetQueryKeys.list(query.status, query.search),
        queryFn: () => apiClient.fixedAssets.getAssets(query),
        staleTime: STALE_TIME_MS,
        placeholderData: keepPreviousData,
    });
};
